import * as THREE from 'three';
import { circleVsCircle } from '../engine/collision.js';

export function spawnShard(game, x, z) {
  const geo = new THREE.BoxGeometry(0.6, 0.6, 0.6);
  const mat = new THREE.MeshStandardMaterial({
    color: 0xff7a33,
    emissive: 0xff7a33,
    emissiveIntensity: 1.2,
  });
  const mesh = new THREE.Mesh(geo, mat);
  mesh.position.set(x, 0.4, z);
  mesh.castShadow = true;
  mesh.userData.dropType = 'shard';
  game.scene.add(mesh);
  game._dropHoverMeta.set(mesh, {
    name: 'FRACTURE SHARD',
    meta: 'VOLATILE',
    hint: 'Explodes near enemies',
  });
  game.shards.push({ mesh, x, z, t: 0 });
}

export function selectHoveredDrop(game) {
  const mouse = game.input?.mouse;
  const cam = game.cameraRig?.camera;
  if (!mouse || !cam || game._dropHoverMeta.size === 0) return null;
  const roots = Array.from(game._dropHoverMeta.keys()).filter((mesh) => !!mesh?.parent);
  if (roots.length === 0) return null;
  game._dropHoverRaycaster.setFromCamera({ x: mouse.ndcX, y: mouse.ndcY }, cam);
  const hits = game._dropHoverRaycaster.intersectObjects(roots, true);
  for (const hit of hits) {
    if (!hit?.object) continue;
    let node = hit.object;
    while (node) {
      const meta = game._dropHoverMeta.get(node);
      if (meta) return meta;
      node = node.parent;
    }
  }
  return null;
}

export function updateDropTooltip(game) {
  if (game.state !== 'playing' || !game.player?.alive) {
    game.hud.hideDropTooltip();
    return;
  }
  const hovered = selectHoveredDrop(game);
  if (!hovered) {
    game.hud.hideDropTooltip();
    return;
  }
  game.hud.showDropTooltip({
    name: hovered.name,
    meta: hovered.meta,
    hint: hovered.hint,
    rarity: hovered.rarity,
  });
  const mouse = game.input.mouse;
  game.hud.moveDropTooltip(mouse.screenX || mouse.x, mouse.screenY || mouse.y);
}

export function updateShards(game, dt) {
  for (let i = game.shards.length - 1; i >= 0; i--) {
    const s = game.shards[i];
    s.t += dt;
    s.mesh.rotation.y += dt * 4;
    s.mesh.position.y = 0.4 + Math.sin(s.t * 6) * 0.08;
    // Detonate on proximity to any enemy or after 5s
    let explode = s.t > 5;
    if (!explode) {
      for (const e of game.enemies) {
        if (!e.alive) continue;
        if (circleVsCircle(s.x, s.z, 0.8, e.x, e.z, e.radius)) { explode = true; break; }
      }
    }
    if (explode) {
      const r = 2.0;
      for (const e of game.enemies) {
        if (!e.alive) continue;
        const d = Math.hypot(e.x - s.x, e.z - s.z);
        if (d <= r + e.radius) e.takeDamage(2, game);
      }
      game.cameraRig.shake(0.35);
      game._flashCircle(s.x, s.z, r);
      game.audio.play('explode', { pitchJitter: 0.1 });
      game._dropHoverMeta.delete(s.mesh);
      game.scene.remove(s.mesh);
      game.shards.splice(i, 1);
    }
  }
}
